import { BMW_BACKOFFICE_PATHS } from '../../bmw-backoffice';
import { PARTNER_TYPES } from '../../partner-types';
import { Roles } from '../../roles';
import { AI_OPERATIONS_ADMIN_ROLES, AI_OPERATIONS_VIEW_ROLES } from '../../request-inbox';
import { MenuItem } from '../types';

export const backofficeSection: MenuItem[] = [
  {
    headTitle1: 'Internal Backoffice',
    type: 'headtitle',
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
  },
  {
    path: '/backoffice/overview',
    icon: 'stroke-home',
    iconf: 'fill-home',
    title: 'Overview',
    type: 'link',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
  },
  {
    // The BMW fleet integration; later BMW pages are added as children (constants/bmw-backoffice.ts).
    title: 'BMW',
    icon: 'stroke-fleet',
    iconf: 'fill-fleet',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: BMW_BACKOFFICE_PATHS.healthCheck,
        title: 'Readiness Check',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: BMW_BACKOFFICE_PATHS.howItWorks,
        title: 'How It Works',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: BMW_BACKOFFICE_PATHS.pagesOverview,
        title: 'Pages & Access',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
    ],
  },
  {
    title: 'Sponsors & Features',
    icon: 'stroke-user',
    iconf: 'fill-user',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/backoffice/sponsors',
        title: 'Sponsors',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/backoffice/sponsor-bulk-update',
        title: 'Bulk Update Sponsors',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.sponsors_admin],
      },
      {
        path: '/backoffice/sponsor-bulk-update/journeys',
        activePathPrefixes: ['/backoffice/sponsor-bulk-update/journeys/'],
        title: 'Bulk Update Journeys',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/backoffice/features',
        title: 'Features',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
    ],
  },
  {
    title: 'List/Fix Price',
    icon: 'stroke-user',
    iconf: 'fill-user',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/backoffice/list-price',
        title: 'Overview',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/backoffice/list-price/price-history',
        title: 'Price History',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/backoffice/list-price/partner-incoming-emails',
        title: 'Incoming Emails',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/backoffice/list-price/contact-management',
        title: 'Contact Management',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/backoffice/list-price/price-adjustment',
        title: 'Price Adjustments',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/backoffice/list-price/partner-discount',
        title: 'Partner Discounts',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/backoffice/list-price/email-preview',
        title: 'Email Preview & Test',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
    ],
  },
  {
    title: 'API Partner Discount',
    icon: 'stroke-user',
    iconf: 'fill-user',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/backoffice/api-partner-discount',
        // Detail routes like `/:id/edit` fall back to this dashboard
        // entry. The Add Discount sibling still wins via exact match.
        activePathPrefixes: ['/backoffice/api-partner-discount/'],
        title: 'API Partner Discounts',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/backoffice/api-partner-discount/new',
        title: 'Add Discount',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
    ],
  },
  {
    title: 'Email Domain',
    icon: 'stroke-user',
    iconf: 'fill-user',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/backoffice/email-domains',
        title: 'Email Domain Management',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/backoffice/email-domains/add',
        title: 'Add Email Domain',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.email_domain_admin],
      },
    ],
  },
  {
    title: 'Order Lookup',
    icon: 'stroke-data-exchange-monitoring',
    iconf: 'fill-data-exchange-monitoring',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/backoffice/order-lookup/audit-logs',
        title: 'Audit Logs',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/backoffice/order-lookup/analytics',
        title: 'Analytics',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
    ],
  },
  {
    title: 'ryd Connect',
    icon: 'stroke-data-exchange-monitoring',
    iconf: 'fill-data-exchange-monitoring',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/backoffice/connect-tracking',
        title: 'Connect Tracking',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
    ],
  },
  {
    title: 'Partner Filter Rules',
    icon: 'stroke-station-management',
    iconf: 'fill-station-management',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/backoffice/partner-filter-rules',
        title: 'Overview',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/backoffice/partner-filter-rules/policies',
        title: 'Policies',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/backoffice/partner-filter-rules/restricted-entities',
        title: 'Restricted Entities',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/backoffice/partner-filter-rules/predefined',
        title: 'Predefined Rules',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/backoffice/partner-filter-rules/decision-check',
        title: 'Decision Check',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
    ],
  },
  {
    title: 'Partner Pricing',
    icon: 'stroke-ecommerce',
    iconf: 'fill-ecommerce',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/backoffice/partner-pricing',
        title: 'Overview',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/backoffice/partner-pricing/lookup',
        title: 'Pricing Lookup',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
    ],
  },
  {
    // Training, configuration and support tools for ryd's AI assistants: Mia (the support chat), the
    // portal assistant and the partner assistants. Moved from Customer Support on 2026-10-25 because
    // AI training serves every ryd team. Each entry keeps the audience it had before the move.
    title: 'AI Assistants',
    icon: 'stroke-learning',
    iconf: 'fill-learning',
    type: 'sub',
    active: false,
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredRoles: [
      ...AI_OPERATIONS_VIEW_ROLES,
      Roles.customer_support_admin,
      Roles.customer_support_agent,
      Roles.operations_admin,
    ],
    children: [
      {
        path: '/backoffice/ai-assistants/overview',
        title: 'Overview',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
      {
        path: '/backoffice/ai-assistants/how-it-works',
        title: 'How It Works',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
      {
        // Read-only view of the AI knowledge collections (what the assistants know) and a retrieval
        // preview. Same audience as the Request Inbox: the ai_operations_* roles.
        title: 'Knowledge Center',
        icon: 'stroke-file',
        iconf: 'fill-file',
        type: 'sub',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        requiredRoles: AI_OPERATIONS_VIEW_ROLES,
        children: [
          {
            path: '/backoffice/ai-assistants/knowledge-center',
            title: 'Collections',
            type: 'link',
            active: false,
            // The articles of a collection and the article page keep this entry active.
            activePathPrefixes: ['/backoffice/ai-assistants/knowledge-center/collections/'],
            requiredUserGroup: ['ryd'],
            requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
            requiredRoles: AI_OPERATIONS_VIEW_ROLES,
          },
          {
            path: '/backoffice/ai-assistants/knowledge-center/test',
            title: 'Test A Question',
            type: 'link',
            active: false,
            requiredUserGroup: ['ryd'],
            requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
            requiredRoles: AI_OPERATIONS_VIEW_ROLES,
          },
        ],
      },
      {
        // Inbound requests per source (T-03, D-57). Phase 1 is a dry run: ticket drafts only, nothing in Odoo.
        // Moved from Customer Support; open to the ai_operations_* roles alone (D-44).
        title: 'Request Inbox',
        icon: 'stroke-email',
        iconf: 'fill-email',
        type: 'sub',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        requiredRoles: AI_OPERATIONS_VIEW_ROLES,
        children: [
          {
            path: '/backoffice/ai-assistants/request-inbox',
            title: 'Overview',
            type: 'link',
            active: false,
            requiredUserGroup: ['ryd'],
            requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
            requiredRoles: AI_OPERATIONS_VIEW_ROLES,
          },
          {
            path: '/backoffice/ai-assistants/request-inbox/messages',
            title: 'Messages',
            type: 'link',
            active: false,
            // The message detail page (/messages/:messageId) keeps this entry active.
            activePathPrefixes: ['/backoffice/ai-assistants/request-inbox/messages/'],
            requiredUserGroup: ['ryd'],
            requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
            requiredRoles: AI_OPERATIONS_VIEW_ROLES,
          },
          {
            path: '/backoffice/ai-assistants/request-inbox/taxonomy',
            title: 'Taxonomy',
            type: 'link',
            active: false,
            requiredUserGroup: ['ryd'],
            requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
            requiredRoles: AI_OPERATIONS_VIEW_ROLES,
          },
          {
            path: '/backoffice/ai-assistants/request-inbox/routing-rules',
            title: 'Routing Rules',
            type: 'link',
            active: false,
            requiredUserGroup: ['ryd'],
            requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
            requiredRoles: AI_OPERATIONS_VIEW_ROLES,
          },
          {
            path: '/backoffice/ai-assistants/request-inbox/sources',
            title: 'Sources',
            type: 'link',
            active: false,
            requiredUserGroup: ['ryd'],
            requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
            requiredRoles: AI_OPERATIONS_ADMIN_ROLES,
          },
          {
            path: '/backoffice/ai-assistants/request-inbox/feedback',
            title: 'Feedback Queue',
            type: 'link',
            active: false,
            requiredUserGroup: ['ryd'],
            requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
            requiredRoles: AI_OPERATIONS_ADMIN_ROLES,
          },
        ],
      },
      {
        title: 'Training',
        icon: 'stroke-learning',
        iconf: 'fill-learning',
        type: 'sub',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        children: [
          {
            path: '/backoffice/ai-assistants/training/cases',
            title: 'Training Cases',
            type: 'link',
            active: false,
            // The case detail page (/cases/:caseId) keeps this entry active.
            activePathPrefixes: ['/backoffice/ai-assistants/training/cases/'],
            requiredUserGroup: ['ryd'],
            requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
            requiredRoles: AI_OPERATIONS_VIEW_ROLES,
          },
          {
            path: '/backoffice/ai-assistants/training/area-rules',
            title: 'Area Rules',
            type: 'link',
            active: false,
            requiredUserGroup: ['ryd'],
            requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
            requiredRoles: AI_OPERATIONS_VIEW_ROLES,
          },
          {
            path: '/backoffice/ai-assistants/training/activation',
            title: 'Activation',
            type: 'link',
            active: false,
            requiredUserGroup: ['ryd'],
            requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
            requiredRoles: AI_OPERATIONS_VIEW_ROLES,
          },
          {
            path: '/backoffice/ai-assistants/training/regression-runs',
            title: 'Regression Runs',
            type: 'link',
            active: false,
            activePathPrefixes: ['/backoffice/ai-assistants/training/regression-runs/'],
            requiredUserGroup: ['ryd'],
            requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
            requiredRoles: AI_OPERATIONS_VIEW_ROLES,
          },
        ],
      },
      {
        title: 'Support Chat',
        icon: 'stroke-chat',
        iconf: 'fill-chat',
        type: 'sub',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        children: [
          {
            path: '/backoffice/ai-assistants/support-chat/settings',
            title: 'Chat Settings',
            type: 'link',
            active: false,
            requiredUserGroup: ['ryd'],
            requiredRoles: [Roles.customer_support_admin, Roles.customer_support_agent],
          },
          {
            // Only usable while code interception is switched on in ryd-end-user-ai; the page says so
            // rather than being hidden, so an agent is not left wondering where the tool went.
            path: '/backoffice/ai-assistants/support-chat/verification-code',
            title: 'Verification Code',
            type: 'link',
            active: false,
            requiredUserGroup: ['ryd'],
            requiredRoles: [Roles.customer_support_admin, Roles.customer_support_agent],
          },
          {
            path: '/backoffice/ai-assistants/support-chat/agent-whitelist',
            title: 'Agent Whitelist',
            type: 'link',
            active: false,
            requiredUserGroup: ['ryd'],
            requiredRoles: [Roles.operations_admin],
          },
        ],
      },
    ],
  },
  {
    title: 'Administration',
    icon: 'stroke-user',
    iconf: 'fill-user',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/backoffice/administration/metadata-sync',
        title: 'Metadata Sync',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.operations_admin],
      },
      {
        path: '/backoffice/administration/cloudflare-firebase-remote-config',
        title: 'Cloudflare Rules',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/backoffice/administration/token-management',
        title: 'Token Lookup',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.operations_admin],
      },
    ],
  },
  {
    title: 'Notifications',
    icon: 'stroke-email',
    iconf: 'fill-email',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/backoffice/notifications/overview',
        title: 'Overview',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        keywords: ['notifications', 'push', 'notification service', 'dispatch'],
      },
      {
        path: '/backoffice/notifications/templates',
        title: 'Notification Templates',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        keywords: ['notification template', 'push text', 'locale', 'wording'],
      },
      {
        path: '/backoffice/notifications/campaigns',
        title: 'Notification Campaigns',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        keywords: ['notification campaign', 'reminder', 'steps', 'nfc reminder'],
      },
      {
        path: '/backoffice/notifications/promotion-campaigns',
        title: 'Promotion Campaigns',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        keywords: [
          'promotion campaign',
          'promo',
          'tags targeting',
          'users reachable',
          'legacy backoffice campaign',
        ],
      },
      {
        path: '/backoffice/notifications/dispatches',
        // Keeps the entry highlighted while a per-dispatch delivery trace is open.
        activePathPrefixes: ['/backoffice/notifications/dispatches/'],
        title: 'Dispatch Monitor',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        keywords: [
          'dispatch',
          'delivery log',
          'push sent',
          'notification status',
          'delivery trace',
        ],
      },
      {
        path: '/backoffice/notifications/test-send',
        title: 'Test Send',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        keywords: ['test push', 'send test notification', 'try out push', 'preflight'],
      },
      {
        path: '/backoffice/notifications/push-tokens',
        title: 'Push Tokens',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        keywords: ['push token', 'device', 'fcm', 'apns', 'token valid'],
      },
      {
        path: '/backoffice/notifications/knowledge-base',
        title: 'Notifications Knowledge Base',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        keywords: ['notification knowledge base', 'delivery funnel', 'opened', 'delivered'],
      },
    ],
  },
];
